import Viewerati from "@quickpoint.me/viewerati";
import { createRoot } from "react-dom/client";
import { nanoid } from "nanoid";

// is the viewer embedded in the author tool
const isInAuthor = !!new URLSearchParams(document.location.search).get(
	"inAuthor",
);

// is the viewer in a pop out window from the author tool
const isInPopOut = !!new URLSearchParams(document.location.search).get("pop");
const popHostId = new URLSearchParams(document.location.search).get("hostId");

// pass container element id to Viewerati
const hostId = popHostId ? popHostId : nanoid();

// Create a React app and render Viewerati properly
const container = document.getElementById("viewerati");
if (container) {
	const root = createRoot(container);

	// Render Viewerati as a React component
	root.render(
		<Viewerati
			containerSelector="viewerati"
			isInAuthor={isInAuthor}
			isInPopOut={isInPopOut}
			isPreviewer={false}
			hostId={hostId}
		/>,
	);
}
